import { UserLight } from "./users";

export type ProjectLight = {
  id: string;
  name: string;
};

export type SearchAdminProject = ProjectLight & {
  location: string;
  designer: string;
  customer: string;
  status: string;
  canEdit: boolean;
  owner: UserLight;
  editor: UserLight;
  modifiedAt: string;
  createdAt: string;
};

export type FullProject = SearchAdminProject & {};

export type UpsertProjectBody = {
  name: string;
  location: string;
  designer: string;
  customer: string;
};

export type SearchProject = {
  id: string;
  name: string;
  location: string;
  designer: string;
  customer: string;
  canEdit: boolean;
  owner: UserLight;
  editor: UserLight;
  modifiedAt: string;
  status: string;
  sharedToOthers: boolean;
};

export type ProjectStatusColor = "success" | "info" | "warning" | "error" | "grey";

export type ProjectStatus = {
  value: string;
  display: string;
  color: ProjectStatusColor;
};

export const getProjectStatusValues = (translations: Record<string, any>): ProjectStatus[] => [
  { value: "offer", display: translations["offer"], color: "grey" },
  { value: "confirmed", display: translations["confirmed"], color: "info" },
  { value: "toBeInstalled", display: translations["toBeInstalled"], color: "warning" },
  { value: "installed", display: translations["installed"], color: "success" },
  { value: "toInspect", display: translations["toInspect"], color: "error" },
  { value: "archived", display: translations["archived"], color: "grey" },
];

export type InviteProjectData = {
  id: string;
  name: string;
  invitedEmail: string;
  language: string;
  author: {
    id: string;
    firstName: string;
    lastName: string;
    email: string;
  };
  sentAt: string;
  actionRequired: boolean;
};
